function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  strokeWidth: ".5",
  strokeLinejoin: "bevel",
  fillRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.45 44.21v-26.7a3.8 3.8 0 013.79-3.79h9.3v2.5H8.52a1.69 1.69 0 000 3.37h29.54c1.89 0 3.24.46 4.08 1.13.8.64 1.32 1.61 1.32 3.12 0 .19.03.38.09.55V44.2a3.8 3.8 0 01-3.8 3.79H8.25a3.8 3.8 0 01-3.79-3.8zm34.02-11.06a3.3 3.3 0 10-6.61 0 3.3 3.3 0 006.6 0zm-.41-16.93H31.9v-2.5h7.85a3.8 3.8 0 013.8 3.8v.07a10.36 10.36 0 00-5.5-1.37zm-17.7-1.02v-4.92H15.8c-1.63 0-2-.92-.83-2.05L22.6.85a3.08 3.08 0 014.25 0l7.63 7.38c1.18 1.13.8 2.05-.83 2.05h-4.57v4.92a1.2 1.2 0 01-1.2 1.19h-6.33c-.65 0-1.19-.53-1.19-1.2z"
})));